module.exports = __webpack_public_path__ + "media/images/news/whatsapp-web-background-cd8b26d02885227aca47e4f294f5af3c.png";